import {
  Directive,
  ElementRef,
  inject,
  InjectionToken,
  OnInit,
} from '@angular/core';
import { ScrollDispatcher } from '@angular/cdk/overlay';
import { filter, map, Observable, tap } from 'rxjs';
import { ComponentStore } from '@ngrx/component-store';
import { DOCUMENT } from '@angular/common';
import { EntitiesStore } from './entities-store.service';

export const LIST_SCROLL_ENTITIES_STORE = new InjectionToken<
  EntitiesStore<any>
>('LIST_SCROLL_ENTITIES_STORE');

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[listScrollLoader]',
  standalone: true,
})
export class ListScrollLoaderDirective
  extends ComponentStore<any>
  implements OnInit
{
  scrollDispatcher = inject(ScrollDispatcher);
  entitiesStore =
    inject(LIST_SCROLL_ENTITIES_STORE, { optional: true }) ||
    inject(EntitiesStore, { optional: true });
  el = inject(ElementRef<any>);

  document = inject(DOCUMENT);

  /*scrollLoadTrigger$ = this.scrollDispatcher
    .ancestorScrolled(this.el, 500)
    .pipe(
      map(() => {
        const viewportHeight = window.innerHeight;
        const contentHeight = this.el.nativeElement.offsetHeight;
        const rawContentAbsoluteY: string = window
          .getComputedStyle(this.el.nativeElement, null)
          .getPropertyValue('padding-top');
        let contentAbsoluteY = 0;
        if (rawContentAbsoluteY) {
          contentAbsoluteY = parseFloat(rawContentAbsoluteY);
        }
        const scrollableDistance =
          contentHeight - viewportHeight + contentAbsoluteY;
        let scrollY = window.scrollY;
        if (scrollerContainer instanceof Window) {
          scrollY = window.scrollY;
        } else {
          scrollY = scrollerContainer.scrollTop;
        }
        const remainingScrollableRatio = scrollY / scrollableDistance;
        /!*            console.log('/////');
        console.log('ClientsComponent', { remainingScrollableRatio });
        console.log('ClientsComponent', { nativeElement });
        console.log('ClientsComponent', { viewportHeight });
        console.log('ClientsComponent', { contentAbsoluteY });
        console.log('ClientsComponent', { contentHeight });
        console.log('ClientsComponent', { scrollableDistance });
        console.log('ClientsComponent', { scrollY });*!/
        // console.log({ remainingScrollableRatio });
        return remainingScrollableRatio > 0.75;
      })
    );*/

  onScrollEnd = this.effect((scrollEnd$: Observable<boolean>) => {
    return scrollEnd$.pipe(
      filter((scrollEnd) => !!scrollEnd),
      tap((scrollEnd) => {
        console.log({ scrollEnd }, 'this.entitiesStore', this.entitiesStore);
        if (this.entitiesStore) {
          this.entitiesStore.loadNextPage();
        }
      })
    );
  });

  ngOnInit(): void {
    const scroll$ = this.scrollDispatcher.ancestorScrolled(this.el, 500);
    const scrollEnd$ = scroll$.pipe(
      map((scrollTarget) => {
        let scrollY: number | undefined;
        let viewportHeight: number | undefined;
        let contentHeight: number | undefined;
        if (!scrollTarget) {
          const window = this.document.defaultView;
          if (window) {
            scrollY = window.scrollY;
            viewportHeight = window.innerHeight;
            contentHeight = this.document.body.offsetHeight;
          }
        } else {
          const { nativeElement } = scrollTarget.getElementRef();
          scrollY = nativeElement.scrollTop;
          viewportHeight = nativeElement.offsetHeight;
          contentHeight = this.el.nativeElement.offsetHeight;
        }
        if (viewportHeight && scrollY && contentHeight) {
          const scrollableDistance = contentHeight - viewportHeight;
          const remainingScrollableRatio =
            Math.round(scrollY) / scrollableDistance;
          console.log({ scrollTarget });
          console.log(
            { contentHeight },
            { scrollableDistance },
            { scrollY },
            { viewportHeight }
          );
          return Math.round(scrollY) + viewportHeight >= contentHeight * 0.8;
        }
        return false;
      })
    );
    this.onScrollEnd(scrollEnd$);
  }
}
